// api
import axioApi from "api/root.api";

// utils
import { getVisitId, getVisitorId } from "utils/visitor";

// guest：持久的 visitor id（後端據此判斷新舊訪客）；visitId：本次頁面載入的 id。見 utils/visitor。
export const getProductInfoUrl = (uid, { visitorId, visitId }) => {
  const params = new URLSearchParams({ guest: visitorId, visitId });
  return `/publish/v1/product/object/${uid}?${params.toString()}`;
};

export const getProductInfo = (uid) => async () => {
  try {
    const urlEnd = getProductInfoUrl(uid, { visitorId: getVisitorId(), visitId: getVisitId() });
    // 不再採用回應 header 的 guest：visitor id 一律以前端 localStorage 為準
    const response = await axioApi.get(urlEnd);
    const result = response.data;
    return result;
  } catch (error) {
    console.log(error);
    return {
      result: false,
      status: "failed",
    };
  }
};
